import {FACILITY_CATEGORY, PAYMENT_TYPE, RESERVATION_STATUS, RESERVATION_TYPE} from '../../CodeMaster'
import {Nullable} from '../../app/TypeHelpers'
import moment, {Moment} from 'moment'

export interface ChargeInformation {
    charge: number
    paymentMethod: PAYMENT_TYPE
}

export default class ReservationCardInformation {
    facilityId: number
    facilityCategory: Nullable<FACILITY_CATEGORY>
    facilityName: string
    imageUrl: Nullable<string>
    facilityReserveId: number
    reserveStatus: RESERVATION_STATUS
    reserverName: Nullable<string>
    reserveTitle: Nullable<string>
    reserveCategory: RESERVATION_TYPE
    chargeInformations: ChargeInformation[]
    reserveStartDatetime: Moment
    reserveEndDatetime: Moment

    constructor(
        facilityId: number,
        facilityCategory: Nullable<FACILITY_CATEGORY>,
        facilityName: string,
        imageUrl: string | null,
        facilityReserveId: number,
        reserveStatus: RESERVATION_STATUS,
        reserverName: string | null,
        reserveTitle: string | null,
        reserveCategory: RESERVATION_TYPE,
        chargeInformations: ChargeInformation[],
        reserveStartDatetime: moment.Moment,
        reserveEndDatetime: moment.Moment,
    ) {
        this.facilityId = facilityId
        this.facilityCategory = facilityCategory
        this.facilityName = facilityName
        this.imageUrl = imageUrl
        this.facilityReserveId = facilityReserveId
        this.reserveStatus = reserveStatus
        this.reserverName = reserverName
        this.reserveTitle = reserveTitle
        this.reserveCategory = reserveCategory
        this.chargeInformations = chargeInformations
        this.reserveStartDatetime = reserveStartDatetime
        this.reserveEndDatetime = reserveEndDatetime
    }

    static from(json: any): ReservationCardInformation {
        return new ReservationCardInformation(
            json.facilityId,
            json.facilityCategory && FACILITY_CATEGORY.codeToEnumConstants(json.facilityCategory),
            json.facilityName,
            json.imageUrl,
            json.facilityReserveId,
            RESERVATION_STATUS.codeToEnumConstants(json.reserveStatus),
            json.reserverName,
            json.reserveTitle,
            RESERVATION_TYPE.codeToEnumConstants(json.reserveCategory),
            json.chargeInformations.map((chargeInfo: any) => ({
                charge: chargeInfo.charge,
                paymentMethod: PAYMENT_TYPE.codeToEnumConstants(chargeInfo.paymentMethod),
            })),
            moment(json.reserveStartDatetime),
            moment(json.reserveEndDatetime),
        )
    }
}
